import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Checkbox } from "antd";
import {
  ModalItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import reporteDeReposicionCajaChicaPdf from "../../../../Pdf/reporteDeReposicionCajaChicaPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class VerReposicionCajaChica extends Component {
  state = {
    loading: false,
    pdf: null,
    mostrarPolizas: false,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    const res = await axios.post(
      "cajaefectivo/datosReposicionCajaChica",
      {
        reposicionId: this.props.id,
        empresaId: this.props.empresaId,
        mostrarPolizas: this.state.mostrarPolizas,
      },
      { headers: this.props.headersToken }
    );

    let polizasContables = [];
    if (this.state.mostrarPolizas && res.data.polizasIds?.length > 0) {
      const resPolizas = await axios.post(
        "polizas/datosPolizas",
        { polizasId: res.data.polizasIds, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );
      if (resPolizas.data.success === 2) {
        polizasContables = resPolizas.data.polizas;
      }
    }

    const pdf = pdfMake.createPdf(
      reporteDeReposicionCajaChicaPdf({ ...res.data, polizasContables })
    );
    this.setState(
      {
        loading: false,
        pdf: pdf,
      },
      () => {
        pdf.open({}, window.frames["reposicionPdf"]);
      }
    );
  }
  cerrarVerReposicionCajaChica() {
    this.setState({ mostrarPolizas: false });
    this.props.cerrarVerReposicionCajaChica();
  }
  onChangeMostrarPolizas(e) {
    this.setState({ mostrarPolizas: e.target.checked }, () => {
      this.consultarTodo();
    });
  }
  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarVerReposicionCajaChica.bind(this)}
        paddingTop
      >
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <Checkbox
            checked={this.state.mostrarPolizas}
            onChange={this.onChangeMostrarPolizas.bind(this)}
          >
            Mostrar pólizas contables
          </Checkbox>
        </div>
        <iframe
          title={"Reposicion Caja Chica"}
          style={{ width: "100%", height: "100vh" }}
          id="reposicionPdf"
          name="reposicionPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerReposicionCajaChica);
